import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyFilledBookIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M6.02077 14.9H13.2938C13.6123 14.9 13.8707 14.6415 13.8707 14.323C13.8707 14.0046 13.6123 13.7461 13.2938 13.7461H6.02077C5.70231 13.7461 5.44385 14.0046 5.44385 14.323C5.44385 14.6415 5.70231 14.9 6.02077 14.9Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.71792 4.69226L4.79458 4.70368V3.12819C4.79458 2.32221 5.45185 1.66666 6.26039 1.66666H14.0792C15.9646 1.66666 17.498 3.19999 17.498 5.08546V14.7434C17.4993 14.7604 17.5 14.7775 17.5 14.7949C17.5 16.7461 15.9111 18.3333 13.9581 18.3333H3.70168C2.89398 18.3333 2.23586 17.6743 2.23586 16.8632V6.1538C2.23586 5.75893 2.39227 5.38799 2.67518 5.11021C2.95723 4.83329 3.33843 4.67346 3.71792 4.69226ZM13.9581 17.0513C15.1891 17.0513 16.1932 16.063 16.2175 14.8402C16.2164 14.8252 16.2159 14.8101 16.2159 14.7949C16.2159 13.5453 15.2022 12.5299 13.9569 12.5299H6.26039C5.45185 12.5299 4.79458 11.8743 4.79458 11.0684V5.9859L3.69911 5.97431C3.63817 5.95543 3.608 5.98837 3.5851 6.01339C3.58108 6.01782 3.57723 6.022 3.57347 6.0256C3.5521 6.04611 3.51792 6.0897 3.51792 6.1538V16.8632C3.51792 16.9684 3.59911 17.0513 3.70168 17.0513H13.9581Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
    </svg>
  );
};

export default IconlyFilledBookIcon;
